import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SaveIcon from "@mui/icons-material/Save";
import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import {
  CEPInput,
  DateInput,
  DocumentInput,
  EmailInput,
  PhoneInput,
  TextFieldComponent,
} from "../../components/misc/form";
import axios from "../../api/axios";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AppBar, IconButton, Toolbar } from "@mui/material";
import useAlert from "../../globalComponents/useAlerts";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CheckBox } from "@mui/icons-material";

const CustomerRegistrationPage = () => {
  const { showLoading, showAlert, dismissLoading } = useAlert();
  const [form, setForm] = useState({
    name: "",
    phone: "",
    document: "",
    type: "PF",
    businessName: "",
    email: "",
    birthdate: "",
    address: {
      street: "",
      number: "",
      complement: "",
      reference: "",
      neighborhood: "",
      zipCode: "",
      city: "",
      state: "",
    },
  });

  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: { birthDate: "" },
  });
  const [loading, setLoading] = useState(false);

  const { birthDate, terms } = watch();

  const handleSubmit = async (form) => {
    try {
      showLoading();

      if (!terms)
        return showAlert({
          title: "Atenção",
          description: `Você precisa ler e aceitar os termos do regulamento do programa!`,
        });

      //adjust date
      const [d, m, y] = form.birthDate.split("/");
      form.birthDate = `${y}-${m}-${d}`;

      const data = await axios.post("/public/customer-register", form);

      showAlert({
        title: "Seja bem vindo!",
        description: `Registro concluído com sucesso. Você será redirecionado para a página de acesso. A senha é a sua data de nascimento (somente números).`,
        onClose: () => navigate("/login-customer", { replace: true }),
      });
    } catch (err) {
      showAlert({ title: "Atenção", description: err.message });
    } finally {
      dismissLoading();
      setLoading(false);
    }
  };

  const onAcceptTerms = (accept) => {
    setValue("terms", accept);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#f8f9fa",
      }}
    >
      <CssBaseline />

      {/* --- CABEÇALHO (HEADER) --- */}
      <AppBar
        position="static"
        elevation={0}
        sx={{ bgcolor: "#ff6a00", color: "#000" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            sx={{ mr: 2, color: "#fff" }}
            onClick={() => navigate("/")}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, fontWeight: 700, color: "#fff" }}
          >
            Voltar
          </Typography>
          <Box component="img" src="logo-fideliza.png" sx={{ height: 80 }} />
        </Toolbar>
      </AppBar>

      {/* --- FUNDO DECORATIVO (IDENTIDADE) --- */}
      <Box
        sx={{
          height: "15vh",
          bgcolor: "#ff6a00",
          backgroundImage: "linear-gradient(180deg, #ff6a00 0%, #ffd569 100%)",
          borderBottomRightRadius: { xs: 40, md: 80 },
        }}
      />

      {/* --- ÁREA PRINCIPAL DO FORMULÁRIO --- */}
      <Container maxWidth="md" sx={{ mt: -10, mb: 4, flexGrow: 1 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid #f0f0f0",
            display: "flex",
            flexDirection: "column",
          }}
          onSubmit={formSubmit(handleSubmit, () =>
            showAlert({
              title: "Atenção",
              description: "Ainda existem campos inválidos!",
            }),
          )}
          component="form"
        >
          {/* Título Interno */}
          <Box sx={{ p: 3, bgcolor: "white", textAlign: "center" }}>
            <Typography variant="h5" fontWeight="900" color="text.primary">
              FORMULÁRIO DE CADASTRO
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Preencha os dados básicos para habilitar o programa de pontos.
            </Typography>
          </Box>

          <Divider />

          {/* Área de Scroll do Formulário */}
          <Box
            sx={{
              p: { xs: 3, sm: 5 },
              maxHeight: "60vh", // Garante que o rodapé da página seja visível
              overflowY: "auto",
              bgcolor: "white",
            }}
          >
            {/* SEÇÃO: DADOS PESSOAIS */}
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ mb: 3 }}
            >
              <Box
                sx={{
                  bgcolor: "primary.main",
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                }}
              >
                <PersonOutlineIcon style={{ color: "#fff" }} />
              </Box>
              <Typography variant="h6" fontWeight="800">
                Dados Pessoais
              </Typography>
            </Stack>

            <Grid container spacing={2.5}>
              <Grid item size={{ xs: 12 }}>
                <TextFieldComponent
                  name="name"
                  control={control}
                  label="Nome Completo"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 7 }}>
                <DocumentInput
                  size="small"
                  control={control}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 5 }}>
                <DateInput
                  name="birthDate"
                  control={control}
                  placeholder="DD/MM/AAAA"
                  label="Data de Nascimento"
                  size="small"
                  fullWidth
                  required
                />
                {/* <TextFieldComponent
                  name="birthDate"
                  control={control}
                  type="date"
                  label="Data de Nascimento"
                  focused={!birthDate}
                  fullWidth
                  required
                /> */}
              </Grid>
              <Grid item size={{ xs: 12, sm: 5 }}>
                <PhoneInput size="small" control={control} fullWidth required />
              </Grid>
              <Grid item size={{ xs: 12, sm: 7 }}>
                <EmailInput size="small" control={control} fullWidth />
              </Grid>
            </Grid>

            <Divider sx={{ my: 5 }} />

            {/* SEÇÃO: ENDEREÇO */}
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ mb: 3 }}
            >
              <Box
                sx={{
                  bgcolor: "primary.main",
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                }}
              >
                <HomeOutlinedIcon style={{ color: "#fff" }} />
              </Box>
              <Typography variant="h6" fontWeight="800">
                Endereço
              </Typography>
            </Stack>

            <Grid container spacing={2} mt={1}>
              <Grid size={{ xs: 12, sm: 8, md: 8 }}>
                <TextFieldComponent
                  name="address.street"
                  control={control}
                  label={"Logradouro"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <TextFieldComponent
                  name="address.number"
                  control={control}
                  label={"Número"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.complement"
                  control={control}
                  label={"Complemento"}
                  fullWidth
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.reference"
                  control={control}
                  label={"Referência"}
                  fullWidth
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 8, md: 8 }}>
                <TextFieldComponent
                  name="address.neighborhood"
                  control={control}
                  label={"Bairro"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <CEPInput
                  size="small"
                  control={control}
                  name="address.zipCode"
                  onAddressFound={(address) => {
                    Object.keys(address).forEach((key) =>
                      setValue(`address.${key}`, address[key], {
                        shouldDirty: true,
                      }),
                    );
                  }}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.city"
                  control={control}
                  label={"Cidade"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.state"
                  control={control}
                  label={"Estado"}
                  fullWidth
                  required
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox onChange={(_, ac) => onAcceptTerms(ac)} />
                    }
                    label="Li e aceito os termos do regulamento"
                  />
                  <Button
                    component="a"
                    target="_blank"
                    href="/regulamento.html"
                  >
                    Ler Regulamento
                  </Button>
                </FormGroup>
              </Grid>
            </Grid>
          </Box>

          <Divider />

          {/* Barra de Ações (Fica "presa" no fundo do Card) */}
          <Box
            sx={{
              p: 3,
              bgcolor: "#fcfcfc",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              loading={loading}
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              startIcon={<SaveIcon />}
              sx={{
                px: { xs: 4, sm: 8 },
                py: 1.5,
                borderRadius: 3,
                fontWeight: 900,
                fontSize: "1rem",
                boxShadow: "0px 8px 20px rgba(251, 176, 22, 0.4)",
                "&:hover": {
                  bgcolor: "#e69d00",
                  boxShadow: "0px 10px 25px rgba(251, 176, 22, 0.5)",
                },
              }}
            >
              FINALIZAR CADASTRO
            </Button>
          </Box>
        </Paper>
      </Container>

      {/* --- RODAPÉ (FOOTER) --- */}
      <Box sx={{ py: 4, mt: "auto", bgcolor: "#424242", color: "white" }}>
        <Container maxWidth="md">
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="body2"
                sx={{ opacity: 0.7, textAlign: { xs: "center", sm: "left" } }}
              >
                © {new Date().getFullYear()} JS Fideliza Construções.
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Stack
                direction="row"
                spacing={3}
                justifyContent={{ xs: "center", sm: "flex-end" }}
              >
                {/* <Typography
                  variant="caption"
                  sx={{
                    opacity: 0.5,
                    cursor: "pointer",
                    "&:hover": { opacity: 1 },
                  }}
                >
                  Suporte
                </Typography> */}
                <Typography
                  component={"a"}
                  href="/regulamento.html"
                  variant="caption"
                  sx={{
                    color: "inherit",
                    opacity: 0.5,
                    cursor: "pointer",
                    "&:hover": { opacity: 1 },
                  }}
                >
                  Regulamento
                </Typography>
                {/* <Typography
                  variant="caption"
                  sx={{
                    opacity: 0.5,
                    cursor: "pointer",
                    "&:hover": { opacity: 1 },
                  }}
                >
                  Termos de Uso
                </Typography> */}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default CustomerRegistrationPage;
